module.exports = citeproc;


//////////////////
// WEBPACK FOOTER
// external "citeproc"
// module id = 713
// module chunks = 6